import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Bidder Approval Request Services
 * !== 공매자 승인 요청 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/bidraprv`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/bidr-usr`,
    nodes: [],
};

export const URLS = {
    ptli0920001q: `${BASE.path}/ptli0920001q`, // Request for company approval List !==  공매자 승인 요청 목록 ==!
    ptli0920002s: `${BASE.path}/ptli0920002s`, // Request for company approval Details !==  공매자 승인 요청 상세 ==!
};

export const APIS = {
    // Check Bidder Approval List !==  공매자 승인 요청 목록 조회 ==!
    getBidrAprvRqstList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Bidder Approval details inquiry !== 공매자 승인 요청 상세 정보 조회 ==!
    getBidrAprvRqstInfo: (xtrnUsrAplyId: any) => {
        return api.get(`${BASE.api}/${xtrnUsrAplyId}`);
    },
    // Execute Bidder User Approval !== 공매자 사용자 승인 ==!
    executeBidrAprv: (data: any) => {
        return api.post(`${BASE.api}/aprv`, {
            ...data,
        });
    },
    // Execute Bidder User Approval !== 공매자 사용자 반려 ==!
    executeBidrRtrn: (data: any) => {
        return api.post(`${BASE.api}/rtrn`, {
            ...data,
        });
    },
};

export const SF_BIDR_APRV_SRCH: TFormSchema = {
    id: "form_bidrAprvSrch",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_BIDR_TIN" },
        usrNm: { type: "text", label: "L_USR_NM" },
        bsopPrcssStat: {
            type: "select",
            label: "L_BSOP_PRCSS_STAT",
            options: [
                { label: "Unprocessed", value: "U" },
                { label: "Approved", value: "A" },
                { label: "Returned", value: "R" },
            ],
            all: true,
        },
    },
};

export const SG_BIDR_APRV_LIST: TGridSchema = {
    id: "grid_bidrAprvList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN_TP", binding: "tinTp", width: 300 }] },
        { cells: [{ header: "L_BIDR_TIN", binding: "xtrnUsrIdntfNo", width: 150 }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: 150 }] },
        { cells: [{ header: "L_TIN_STAT", binding: "tinStat", width: "*" }] },
        { cells: [{ header: "L_BSOP_PRCSS_STAT", binding: "bsopPrcssStat", width: "*" }] },
        { cells: [{ header: "L_DELY_YN", binding: "delyYn", width: 150 }] },
    ],
    body: [
        {
            cells: [{ binding: "tinTp" }],
        },
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }],
        },
        {
            cells: [{ binding: "usrNm" }],
        },
        {
            cells: [{ binding: "tinStat" }],
        },
        {
            cells: [{ binding: "bsopPrcssStat" }],
        },
        {
            cells: [{ binding: "delyYn" }],
        },
    ],
};

export const SF_USR_APLY_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN_NO" },
        usrNm: { type: "text", label: "L_USR_NM" },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md" },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO" },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10 },
        usrPwd: { type: "password", label: "L_USR_PWD" },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM" },
        aprvYn: { type: "text", label: "L_APRV_YN" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        preXtrnUsrAplyId: { type: "text", label: "L_PRE_XTRN_USR_APLY_ID" },

        coAplyId: { type: "text", label: "L_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        inwdCoYn: {
            type: "radio",
            label: "L_INWD_CO_YN",
            options: [
                { label: "Domestic Company", value: "Y" },
                { label: "Foreign Company", value: "N" },
            ],
            defaultValue: "Y",
        },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
    },
};
